<div class="header" [ngClass]="{zIndexClass: showHeader}">
  <app-header *ngIf="showHeader" [headerRTL]='showRTL' ></app-header>
</div>
<div class="body" [ngClass]="{'rtl': showRTL}" >
  <router-outlet></router-outlet>
</div>
<div *ngIf="showHeader" class="button">
  <a class="link" target="_blank" href="https://ticket.instavans.com">Support</a>
</div>